module.exports = __webpack_public_path__ + "9e62b82dafcbdc76394832db736579d7.pdf";